import { Button, Box, Grid, CardMedia, Typography } from "@mui/material";
import {
  Code,
  Commit,
  NavigateNext,
  AccountTreeOutlined,
} from "@mui/icons-material";
import { getLayoutView } from "../../../components/layout/getLayoutView";
import { getLayoutText } from "../../../components/layout/getLayoutText";
import { useEffect, useRef } from "react";
const Showcase = () => {
  const ref0 = useRef(null);
  useEffect(() => {
    if (ref0.current) {
      ref0.current.setAttribute("muted", "");
    }
  }, []);
  return (
    <Box sx={{ backgroundColor: `white` }}>
      <Grid
        className="wrapper"
        container
        sx={{
          color: (theme) => theme.palette.grey[600],
          "&.wrapper": {
            position: `relative`,
            width: `100%`,
          },
          "&.wrapper::after": {
            position: `absolute`,
            top: 0,
            left: 0,
            width: `100%`,
            height: ` 100%`,
            content: `""`,
            backgroundImage: (theme) => ({
              ...{
                xs: `linear-gradient(
                  90deg,
                  ${theme.palette.grey[900]}bb 100%,
                  ${theme.palette.grey[900]}bb 100%
                )`,
                md: `linear-gradient(
                  90deg,
                  ${theme.palette.primary.main}70 50%,
                  ${theme.palette.grey[900]}bb 50%,
                  ${theme.palette.grey[900]}bb 100%
                )`,
              },
            }),
          },
        }}
      >
        <Grid
          item
          xs={12}
          lg={12}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: `space-between`,
            "& .video-container": {
              minHeight: `500px`,
              position: `relative`,
            },
            "& .video-container video": {
              width: `100%`,
              height: `100%`,
              position: `absolute`,
              objectFit: `cover`,
              objectPosition: `50% 58.5%`,
              zIndex: 0,
            },
            "& .video-container .caption": {
              zIndex: 1,
              position: `relative`,
              color: `#dc0000`,
              padding: `10px`,
            },
          }}
        >
          <Box className="video-container wrapper">
            {/* <video
              src={demo}
              alt="demo"
              playsInline
              autoPlay
              muted
              loop
            ></video> */}
            <CardMedia
              ref={ref0}
              component="video"
              image={"https://website-img.polycaik.com/w/asset/58948eaf141b43d5bf839db176812d06.mp4"}
              src={"https://website-img.polycaik.com/w/asset/58948eaf141b43d5bf839db176812d06.mp4"}
              alt="demo"
              playsInline
              autoPlay
              muted
              loop
            />
            <Box
              className="caption"
              sx={{
                m: { xs: 0, md: `0 50%` },
                width: { xs: `100%`, md: `50%` },
                maxWidth: "900px",
              }}
            >
              {getLayoutView(
                <>
                  APPLY FOR OUR{" "}
                  <span style={{ fontFamily: "Lato-Bold" }}> DEVELOPER</span>{" "}
                  COHORT
                </>,
                [
                  getLayoutText(
                    <>
                      GET EARLY ACCESS TO THE LATEST{" "}
                      <span>FEATURES AND LEARNING MATERIALS</span> TO LEVERAGE{" "}
                      POLYCAIK IN YOUR WORKFLOWS
                    </>,
                    {
                      fontSize: "16px",
                      fontFamily: "Lato-Bold",
                      lineHeight: 2.25,
                    }
                  ),
                  <Button
                    endIcon={<NavigateNext />}
                    sx={{
                      px: 0,
                      color: "primary.main",
                      backgroundColor: "transparent",
                      "&:hover": {
                        color: (theme) => theme.palette.grey[400],
                        backgroundColor: "transparent",
                      },
                    }}
                    href={`/developers`}
                  >
                    LEARN MORE
                  </Button>,
                ],
                [12],
                {
                  p: `6rem 10%`,
                  backgroundColor: `transparent`,
                  "& .MuiTypography-root:not(.MuiTypography-caption)": {
                    color: `white`,
                  },
                }
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
export default Showcase;
